// extracted by mini-css-extract-plugin
module.exports = {"submitButtons":"submitAssessment__submitButtons___DMa6I","activeButton":"submitAssessment__activeButton___nF4Pu"};